import { render, staticRenderFns } from "./ResultNumbers.vue?vue&type=template&id=be1e8272&"
import script from "./ResultNumbers.vue?vue&type=script&lang=js&"
export * from "./ResultNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports